import React from 'react'
import * as S from './styles'

export default function StatusChip({ status, cancellationStatus }) {
  if (!status && !['analysis', 'canceled'].includes(cancellationStatus)) return null

  const statusLabels = {
    analysis: 'Em Andamento',
    pixError: 'Ação pendente',
    inProgress: 'Em Andamento',
    done: 'Concluído',
    canceled: 'Pedido excluído'
  }

  const label = statusLabels[status] || statusLabels[cancellationStatus] || status

  return <S.StatusBadge variant={status || cancellationStatus}>{label}</S.StatusBadge>
}
